import { set } from "date-fns";
import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Schedule component receives eventSchedule as a prop
const Schedule = ({ venueFromEventListAPI, eventName}) => {
  

 // State variables
const [venues, setVenues] = useState(null); // Stores the list of venues fetched from the API.
const [venueSelected, setVenueSelected] = useState("Select Venue"); // Keeps track of the selected venue.
const [dates, setDates] = useState(null); // Stores available dates for the selected venue.
const [datesArr, setDatesArr] = useState(null); // Contains the list of date strings derived from 'dates'.
const [timeArr, setTimeArr] = useState(null); // Contains the list of available time slots for a selected date.
const [selectedDate, setSelectedDate] = useState(null); // Stores the currently selected date.
const [dateId, setDateId] = useState(null); // Stores the index of the selected date in 'datesArr'.
const [selectedTime, setSelectedTime] = useState(null); // Stores the currently selected time slot.
const [dateSelected, setDateSelected] = useState("Select"); // Keeps track of the displayed label for the selected date.
const [timeSelected, setTimeSelected] = useState("Select"); // Keeps track of the displayed label for the selected time.
const [isDateBtnPressed, setIsDateBtnPressed] = useState(false); // Indicates whether a date button has been pressed.
const [isTimeBtnPressed, setIsTimeBtnPressed] = useState(false); // Indicates whether a time button has been pressed.

// Refs
const venueDropDownRef = useRef(); // Reference to the venue dropdown element for toggling visibility.
const dateDropDownRef = useRef(); // Reference to the date dropdown element for toggling visibility.
const timeDropDownRef = useRef(); // Reference to the time dropdown element for toggling visibility.
const dateBtnRef = useRef(); // Reference to the date button element.
const timeBtnRef = useRef(); // Reference to the time button element.
const prevDatebtn = useRef(null); // Keeps track of the previously selected date button.
const prevTimebtn = useRef(null); // Keeps track of the previously selected time button.

const navigate = useNavigate()

// Effects


// Get seat details




useEffect(() => {
  setVenues(venueFromEventListAPI); // Initialize the venues state with data from the API.
}, [venueFromEventListAPI]);

useEffect(() => {
  if (venues && venues.length === 1) {
    selectVenue(venues[0].name, 0); // Auto-select the only venue if there's only one.
  }
}, [venues]);

useEffect(() => {
  if (dates) {
    const datesArrFromEventListAPI = dates.map(({ date }) => date); // Extract date strings from the 'dates' object.
    setDatesArr(datesArrFromEventListAPI); // Set 'datesArr' with extracted date strings.
  }
}, [dates]);

useEffect(() => {
  if (datesArr && datesArr.length === 1) {
    dateBtnRef.current.click(); // Auto-click the date button if there's only one date.
    setIsDateBtnPressed(true);
  }
}, [datesArr]);

useEffect(() => {
  if (isDateBtnPressed && selectedDate && dateId !== null && dates[dateId]) {
    const timesArrFromEventListAPI = dates[dateId].times.map(({ time }) => time); // Extract times for the selected date.
    setTimeArr(timesArrFromEventListAPI); // Update the state with available time slots.
  }
}, [isDateBtnPressed, selectedDate, dateId, dates]);

useEffect(() => {
  if (timeArr && timeArr.length === 1) {
    timeBtnRef.current.click(); // Auto-click the time button if there's only one time slot.
    setIsTimeBtnPressed(true);
  } else {
    setIsTimeBtnPressed(false); // Reset the time button state if there are multiple options.
  }
}, [timeArr]);

useEffect(() => {
  if (!dates || !selectedDate) return;

  const filterDateArr = dates.filter((date) => selectedDate === date.date); // Filter dates matching the selected date.
  if (!filterDateArr.length) return;

  if (selectedTime) {
    const filterTimeArr = filterDateArr[0].times.filter(
      (time) => selectedTime === time.time
    ); // Filter times matching the selected time.
    if (filterTimeArr.length) {
      localStorage.evdt_id = filterTimeArr[0].evdt_id; // Store the event date-time ID in local storage.
    }
  }
}, [selectedDate, selectedTime, dates]);

useEffect(() => {
  localStorage.eventName = eventName; // Save the event name in local storage.
  localStorage.eventVenue = venueSelected; // Save the event venue in local storage.
  if (selectedDate) localStorage.selectedDateOfTheEvent = selectedDate; // Save the selected date in local storage.
  if (selectedTime) localStorage.selectedTimeOfTheEvent = selectedTime; // Save the selected time in local storage.
}, [eventName, selectedDate, selectedTime, venueSelected]);

// Handlers
const selectVenue = (venue, ind) => {
  setVenueSelected(venue); // Update the selected venue.
  venueDropDownRef.current.classList.remove("active"); // Close the venue dropdown.

  const selectedVenueDates = venueFromEventListAPI[ind].dates; // Get dates for the selected venue.
  setDates(selectedVenueDates);
  setDatesArr(null); // Reset the dates array.
  setSelectedDate(null); // Clear the selected date.
  setDateId(null); // Reset the date ID.
  setTimeArr(null); // Clear the time slots array.
  setSelectedTime(null); // Clear the selected time.
  setTimeSelected("Select"); // Reset the time label.
};

const selectDate = (e, ind) => {
  setSelectedDate(datesArr[ind]); // Update the selected date.
  setSelectedTime(null); // Clear the selected time.
  setDateId(ind); // Update the date ID.
  setDateSelected(datesArr[ind]); // Update the displayed label for the date.
  setTimeSelected("Select"); // Reset the time label.
  dateDropDownRef.current.classList.remove("active"); // Close the date dropdown.

  if (prevDatebtn.current) {
    prevDatebtn.current.classList.remove("selected"); // Deselect the previously selected date button.
    setIsDateBtnPressed(false); // Reset the date button state.
  }
  prevDatebtn.current = e.target; // Set the current button as the previous one.
  prevDatebtn.current.classList.add("selected"); // Highlight the selected date button.
  setIsDateBtnPressed(true); // Update the date button state.
};

const selectTime = (e, ind) => {
  setSelectedTime(timeArr[ind]); // Update the selected time.
  setTimeSelected(timeArr[ind]); // Update the displayed label for the time.
  timeDropDownRef.current.classList.remove("active"); // Close the time dropdown.

  if (prevTimebtn.current) {
    prevTimebtn.current.classList.remove("selected"); // Deselect the previously selected time button.
    setIsTimeBtnPressed(false); // Reset the time button state.
  }
  prevTimebtn.current = e.target; // Set the current button as the previous one.
  prevTimebtn.current.classList.add("selected"); // Highlight the selected time button.
  setIsTimeBtnPressed(true); // Update the time button state.
};

const viewVenue = () => {
  venueDropDownRef.current.classList.toggle("active"); // Toggle the venue dropdown visibility.
  dateDropDownRef.current?.classList.remove("active"); // Ensure the date dropdown is closed.
  timeDropDownRef.current?.classList.remove("active"); // Ensure the time dropdown is closed.
};

const viewDate = () => {
  dateDropDownRef.current.classList.toggle("active"); // Toggle the date dropdown visibility.
};

const viewTime = () => {
  timeDropDownRef.current.classList.toggle("active"); // Toggle the time dropdown visibility.
};

function toTheCheckout(){
 navigate(`/Checkout?evdt_id=${localStorage.evdt_id}`)
}


  return (
    <>
      <div className="wrapper">
        <div className="schedule-Wrapper flexB">
          <div className="eventName_and_Location">
            <h2 className="eventName">
              <b>{eventName}</b>
            </h2>
            <div className="select_Venue">
             <div className="pick-venue">
             <button className="viewVenues" onClick={viewVenue}>{venueSelected}</button>
             <div className="venue-wrapper" ref={venueDropDownRef}>
  {venues &&
    
    <div className="venues flexB">

     {
      venues.map((venue, ind) => (
        <button
          key={ind}
          onClick={() => selectVenue(venue.name, ind)}
          disabled={venue.name === venueSelected} // Disable if the venue is already selected
          className={venue.name === venueSelected ? "venue_Btn disabled" : "venue_Btn"}
        >
          {venue.name}
        </button>
      ))
     }

    </div>
    
    }
</div>
             </div>
            </div>
          </div>

          <div className="date_and_time flexB">
            <div className="pick-date">
              <div className="date_label text-center">
                <p>Date</p>
              </div>
              <button className="viewDates" onClick={viewDate}>
                {dateSelected}
              </button>

              <div className="date-wrapper" ref={dateDropDownRef}>
                <div className="dates flexB">
                {datesArr? datesArr.map((date, ind) => (
    <button
      key={ind}
      ref={dateBtnRef}
      className={`date ${datesArr.length !== 1 ? 'visible' : ''}`}
      onClick={(e) => {
        selectDate(e, ind);
      }}
    >
      {date}
    </button>
  )): <button className="date">Choose a venue</button>}                
                </div>
              </div>
            </div>

            <div className="pick-time">
              <div className="time_label text-center">
                <p>Time</p>
              </div>
              <button className="viewTimes" onClick={viewTime}>
                {timeSelected}
              </button>

              <div className="time-wrapper flexB " ref={timeDropDownRef}>
                {!timeArr && <button className="time">Choose a date</button>}
                {timeArr &&
                  timeArr.length !== 1 &&
                  timeArr.map((time, ind) => (
                    <button
                      className="time visible"
                      key={ind}
                      onClick={(e) => {
                        selectTime(e, ind);
                      }}
                    >
                      {time}
                    </button>
                  ))}

                {timeArr &&
                  timeArr.length === 1 &&
                  timeArr.map((time, ind) => (
                    <button
                      className="time selected"
                      key={ind}
                      ref={timeBtnRef}
                      onClick={(e) => {
                        selectTime(e, ind);
                      }}
                    >
                      {time}
                    </button>
                  ))}
              </div>
            </div>

            <div className="bookTickets-Wrapper flexB">
              {isDateBtnPressed && isTimeBtnPressed ? (
                <button onClick={toTheCheckout} to="/Checkout" className="bookTickets visible">
                  Book Tickets
                </button>
              ) : (
                <button className="bookTickets">Book Tickets</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;
